import { api } from '@/api';
import { RtSystemCategory, type RtSystemQuantityScopeDto } from '@/api/generator';
import { useActionWithConfirmation } from '@/components/confirmationModals/useActionWithConfirmation';
import type { ScopeType } from '@/utils/translationPrefix';

export function useDeleteTextWithConfirmation() {
  return useActionWithConfirmation({
    confirmedAction: async (id: string) =>
      await api.textsApi.deleteText({
        id,
      }),
  });
}

/**
 * Texts store medical systems and QA equipment in one flat `setupScope` list.
 * The translations differ per scope type, so we derive it from the category.
 */
export function getScopeType(scope: Pick<RtSystemQuantityScopeDto, 'rtSystemCategory'>): ScopeType {
  return scope.rtSystemCategory === RtSystemCategory.QaEquipment
    ? 'qaEquipmentScope'
    : 'medicalSystemScope';
}
